import components from "components/components";
import Layers from "slotworks/graphics/layers/layers";
import settingsModel from "slotworks/model/settings/settings-model";
import deviceInfo from "slotworks/utils/device-info";

export default class MessagesComponent {

    private layer: Layers;

    constructor() {
        this.layer = Layers.Custom.get("Messages");
        this.startFooter();
    }

    public setDefault() {
        this.layer.defaultScene().execute();
    }

    public setFreespins(boosters: number) {
        if (boosters > 0) {
            this.layer.setScene("freespins" + boosters + "boosters").execute();
        } else {
            this.layer.setScene("freespins").execute();
        }
    }

    private startFooter() {
        if (!deviceInfo.isDesktop) {
            const updateScatterMessage = () => {
                const scatters = Layers.Footer.getSprite("scatters");
                const scattersNoBuy = Layers.Footer.getSprite("scatters_no_buy");
                if (scatters && scattersNoBuy) {
                    if (!settingsModel.isUKJurisdiction() && settingsModel.buyoutEngine) {
                        scattersNoBuy.visible = false;
                    } else {
                        scatters.visible = false;
                    }
                }
            }
            Layers.Footer.onSceneEnter.add(updateScatterMessage);
            deviceInfo.onLayoutChange.add(() => setTimeout(updateScatterMessage, 1))
            updateScatterMessage();
        }
    }

    /**
     * default
     * freespins
     * freespins1boosters
     * freespins2boosters
     * freespins3boosters
     * freespins4boosters
     * freespins5boosters
     */
}